<div class="row apt-container justify-content-center mb-4">
  <div class="col-2 text-center apt-timeline">
    <div class="bullet"></div>
    <div class="apt-time-text my-1"><strong>{{appointment.start | date:'HH:mm'}}</strong></div>
    <div class="v-line"></div>
  </div>
  <div class="col-10 apt-details text-capitalize" [ngClass]="{'disabled-card': appointment.isDeleted}">
    <mat-card class="apt-details-card" [ngClass]="{'pointer': !appointment.isDeleted && isRowClickable}" (click)="onRowClicked()"
      onKeyDown="doNothing();" tabindex="0">
      <mat-card-header>
        <mat-card-title-group>
          <mat-card-title class="u-name text-capitalize">{{appointment.patient.firstName}}
            {{appointment.patient.lastName}}</mat-card-title>
        </mat-card-title-group>
      </mat-card-header>
      <mat-card-content class="mt-3 ">
        <div class="row">
          <div class="col-4">
            <div class="label">Visit Type</div>
            <div class="value">{{appointment.appointmentType}}</div>
          </div>
          <div class="col-4">
            <div class="label">Duration</div>
            <div class="value">{{appointment.start | timeDifference:appointment.end}}</div>
          </div>
          <div class="col-4">
            <div class="label">Action</div>
            <div [ngClass]="{'disabled-card': appointment.isDeleted}" fxLayout="row wrap" fxLayoutAlign="center start"
              fxLayoutGap="8px">
              <ng-container *ngIf="!appointment.isDeleted">
                @if(!appointment.doNotshowDeleteBtn){
                <button type="button" mat-icon-button class="md-small"
                  [ngClass]="{'disabled-card': appointment.hasTranscription}" (click)="onAction($event,'delete')">
                  <i class="bi bi-trash3"></i>
                </button>
                }
                <button type="button" mat-icon-button class="md-small"
                  [ngClass]="{ 'disabled': !appointment.hasTranscription}" (click)="onAction($event,'transcription')">
                  <img
                    [src]="appointment.hasTranscription ? ( appointment.pastAppointment ? cvaUI_url + '/assets/icons/notes-readonly.svg' : cvaUI_url + '/assets/icons/notes.svg') : cvaUI_url+'/assets/icons/notes-disabled.svg' "
                    alt="transcription" class="icon">
                </button>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="label">Reason</div>
            <div class="value notes-field text-break" [cvaTrimText]="appointment.notes">
              {{ appointment.notes }}
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>